import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import Panne from "./components/Panne";
import Remplacement from "./components/Remplacement";
import QuelMoteur from "./components/QuelMoteur";
import AutresMarques from "./components/AutresMarques";
import ReparerPlutot from "./components/ReparerPlutot";
import CTAAppel from "./components/CTAAppel";
import FAQ from "./components/FAQ";
import Galerie from "./components/Galerie";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";

export default function MoteurSomfyPage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Moteur Somfy Volet Roulant Strasbourg | Remplacement"
        description="Remplacement de moteur Somfy pour volet roulant à Strasbourg et dans le Bas-Rhin. Spécialistes io et RTS, télécommandes Telis et Situo. Devis gratuit. 03 74 47 32 40."
        path="/moteur-somfy"
        type="service"
        serviceType="Remplacement de moteur Somfy"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Moteur Somfy" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Moteur Somfy" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Reassurances />
        <Panne />
        <Remplacement />
        <QuelMoteur />
        <AutresMarques />
        <ReparerPlutot />
        <CTAAppel />
        <FAQ />
        <Galerie />
        <Maillage />
        <Formulaire />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}